import { render, staticRenderFns } from "./EducationView.vue?vue&type=template&id=2ac9e260&"
import script from "./EducationView.vue?vue&type=script&lang=js&"
export * from "./EducationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports